exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nli span.styling-a[data-v-0183cdec] {\n    padding-left:10px;\n    background: #dc354f;\n}\nli span.styling-b[data-v-0183cdec] {\n    padding-left:10px;\n    background: #32b8d6;\n}\nli span.styling-c[data-v-0183cdec] {\n    padding-left:10px;\n    background: #34e479;\n}\nli span.styling-d[data-v-0183cdec] {\n    padding-left:10px;\n    background: #d7ea34;\n}\n", ""]);

// exports
